import { render, staticRenderFns } from "./ProfissionalForm.vue?vue&type=template&id=4f118d85"
import script from "./ProfissionalForm.vue?vue&type=script&lang=js"
export * from "./ProfissionalForm.vue?vue&type=script&lang=js"
import style0 from "./ProfissionalForm.vue?vue&type=style&index=0&id=4f118d85&prod&lang=scss"
import style1 from "./ProfissionalForm.vue?vue&type=style&index=1&id=4f118d85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports